import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';
import { LocationVarKey } from '@swivl-mono/types';
import {TextRow, Indent, InputRow, TextAreaRow, DropdownRow, MultiLineRow, SwitchRow, SectionHeader, PageHeader } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponents';
import { IS_NOT_EQUAL, IS_EQUAL, IS_TRUE } from '../../../Components/Worksheets/Types/Worksheet.Interface';

export default  function WorksheetView() {
    const page = usePropertiesGetLocationIds();  
  return  <>
        <PageHeader {...page} 
        subheading=""
        > Due Date</PageHeader>

        <SwitchRow {...page}  keyName= {LocationVarKey.LLMAccountChangeDueDate} label="✨ Enhance with AI" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement,"1")}/>   
        <TextRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.LLMAccountChangeDueDate,"1")}>
            <div className="rainbowPower">
            Your AI assistant will enhance the answer below using contextual data from the customer’s profile, conversation history, and your knowledge graph.
            </div>
        </TextRow>
           
        <DropdownRow {...page}  
            marginTop
            label=" Due on"
            keyName= {LocationVarKey.ChangeDueDateSelection}
            options={[
                {
                    label:"Custom",
                    value:"custom"
                },
                {
                    label:"1st of the Month",
                    value:"1st"
                },
                {
                    label:"15th of the Month",
                    value:"15th"
                },
                {
                    label:"Anniversary Date",
                    value:"anniversary"
                }

            ]} /> 
        
        <TextAreaRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection,"custom")}
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.ChangeDueDate1}
        />
        <TextAreaRow {...page}   hideIf={IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection,"custom")}
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.ChangeDueDate2}
            enableSwitchVar={LocationVarKey.ChangeDueDate2Enabled}
        />

        <TextAreaRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection,"1st")}
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.ChangeDueDate3}
        />
        <TextAreaRow {...page}   hideIf={IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection,"1st")}
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.ChangeDueDate4}
            enableSwitchVar={LocationVarKey.ChangeDueDate4Enabled}
        />

        <TextAreaRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection,"15th")}
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.ChangeDueDate5}
        />
        <TextAreaRow {...page}   hideIf={IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection,"15th")}
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.ChangeDueDate6}
            enableSwitchVar={LocationVarKey.ChangeDueDate6Enabled}
        />

        <TextAreaRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection,"anniversary")}
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.ChangeDueDate7}
        />
        <TextAreaRow {...page}   hideIf={IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection,"anniversary")}
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.ChangeDueDate8}
            enableSwitchVar={LocationVarKey.ChangeDueDate8Enabled}
        />

        <SwitchRow {...page}  keyName= {LocationVarKey.HasChangeDueDate} label="Customers can change due date"/>


    </>
}